import React, { Component } from 'react'
import classNames from 'classnames'
import styles from './TextField.module.scss'
import { ErrorPosition, ITextField } from 'components/atoms/TextField/text-field.types'
import { useHover } from 'react-use'
import Info from '../Svgs/Info'
import Tooltip from '../Tooltip/Tooltip'

interface ITextFieldProps extends ITextField {
  name?: string
  inputComponent?: React.ReactNode
  labelHint?: string
}

const TextField: React.FC<ITextFieldProps> = ({
  id = '',
  className,
  disabled,
  label,
  labelHint,
  required = false,
  name = '',
  error,
  noOutline,
  dark = false,
  inputComponent,
  errorPosition = ErrorPosition.top,
}: ITextFieldProps) => {
  const _id = id || name

  const classes = classNames([styles.root, className], {
    [styles['is-disabled']]: !!disabled,
    [styles['has-error']]: error,
    [styles['no-outline']]: !!noOutline,
    [styles.dark]: dark,
  })

  const [hoverableInfoIcon, isHovering] = useHover(
    <div className={styles['info-icon']}>
      <Info width={20} height={20} />
    </div>,
  )

  return (
    <div className={classes}>
      {label && (
        <label htmlFor={_id}>
          {label}
          {required && <span className={styles.required}> *</span>}
          {error && errorPosition === ErrorPosition.top && ` - ${error as string}`}
          {labelHint && (
            <Tooltip isOpen={isHovering} body={labelHint}>
              {hoverableInfoIcon}
            </Tooltip>
          )}
        </label>
      )}

      {!label && error && errorPosition === ErrorPosition.top && <label>{error as React.ReactNode}</label>}

      {inputComponent}

      {error && errorPosition === ErrorPosition.bottom && <label>{error as React.ReactNode}</label>}
    </div>
  )
}

export default TextField
